<template>
  <v-container>
    <v-tabs v-model="tab" background-color="white" color="#d32f2f">
      <v-tab>
        Mensagens
      </v-tab>
      <!-- <v-tab>
        Tópicos
      </v-tab> -->
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item>
        <Mensagens />
      </v-tab-item>
      <v-tab-item>
        <!-- <Topicos /> -->
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
  import Mensagens from "./components/Mensagens.vue";
  // import Topicos from "./components/Topicos.vue";
export default {

  components: {
    Mensagens,
    // Topicos
  },

  data(){
    return{
      tab: null
    };
  }
}
</script>

<style scoped>
.v-tab:not(.v-tab--active) {
  color: #d32f2f !important;
}
</style>
